import { Reveal, SectionHeader } from "./Reveal";
import AdirondackSchema from "./AdirondackSchema";
import { useLang } from "@/i18n";

const B = (n) => `/images/logements/bungalow/${n}.jpg`;

export default function Jacuzzi() {
  const { t } = useLang();

  return (
    <section
      id="jacuzzi"
      data-testid="jacuzzi-section"
      className="py-24 sm:py-32 px-5 sm:px-10"
    >
      <div className="mx-auto max-w-[1500px]">
        <SectionHeader eyebrow={t.jacuzzi.eyebrow} title={t.jacuzzi.title} />

        <div className="grid lg:grid-cols-2 gap-14 mt-12">
          <div className="grid grid-cols-2 gap-4 items-start" data-testid="jacuzzi-photos">
            <Reveal delay={0.1}>
              <div className="col-span-2">
                <img
                  src={B("13-jacuzzi-pov")}
                  alt="Vue depuis l'eau du jacuzzi : la mer des Caraïbes et la marina de Rivière Sens"
                  data-testid="jacuzzi-photo-main"
                  loading="lazy"
                  className="w-full aspect-[5/4] object-cover border gold-hairline"
                />
              </div>
            </Reveal>
            <Reveal delay={0.15}>
              <img
                src={B("06-jacuzzi-paillote")}
                alt="Le jacuzzi de 5 places au bord de la fosse de la piscine"
                loading="lazy"
                className="w-full aspect-[4/3] object-cover border gold-hairline"
              />
            </Reveal>
            <Reveal delay={0.2}>
              <img
                src={B("05-jacuzzi-ronde")}
                alt="Le jacuzzi rond vu de la terrasse"
                loading="lazy"
                className="w-full aspect-[4/3] object-cover border gold-hairline"
              />
            </Reveal>
            <Reveal delay={0.25}>
              <AdirondackSchema />
            </Reveal>
          </div>

          <div className="space-y-5" data-testid="jacuzzi-text">
            {t.jacuzzi.paras.map((p, i) => (
              <Reveal key={i} delay={0.05 * i}>
                <p className="text-sm sm:text-base text-mist font-light leading-relaxed">
                  {p}
                </p>
              </Reveal>
            ))}

            <Reveal delay={0.25}>
              <div
                className="mt-6 border-l-2 border-gold/70 pl-5 sm:pl-6"
                data-testid="jacuzzi-solar"
              >
                <p className="font-display italic text-lg sm:text-xl text-bone/90 font-light leading-snug">
                  {t.jacuzzi.solar}
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
